import { memo, useCallback } from 'react';

import { type AirActionTrackingLocation } from '@air/analytics';
import { type AssetCustomFieldValue } from '@air/api/types';

import { CustomFieldPlainTextTableCellInput } from '~/components/TableView/TableRow/CustomFieldTableCell/CustomFieldPlainTextTableCellInput';
import { useUpdatePublicItemsCustomFieldValue } from '~/utils/CustomFields/useUpdatePublicItemsCustomFieldValue';

export type PublicAssetCustomFieldPlainTextInputTableCellProps = {
  field: AssetCustomFieldValue;
  trackingLocation: AirActionTrackingLocation;
  assetId: string;
  closeEditor: () => void;
};

export const PublicAssetCustomFieldPlainTextInputTableCell = memo(
  ({ field, trackingLocation, assetId, closeEditor }: PublicAssetCustomFieldPlainTextInputTableCellProps) => {
    const { updatePublicItemsCustomFieldValue } = useUpdatePublicItemsCustomFieldValue();

    const onSubmit = useCallback(
      async (value: string) => {
        if (!assetId) return;
        await updatePublicItemsCustomFieldValue({
          assetIds: [assetId],
          baseCustomField: field,
          nextPlainTextValue: value,
          trackingLocation,
        });
      },
      [assetId, updatePublicItemsCustomFieldValue, field, trackingLocation],
    );

    return (
      <CustomFieldPlainTextTableCellInput
        onBlur={closeEditor}
        defaultValue={field.plainTextValue}
        onSubmit={onSubmit}
        fieldName={field.name}
      />
    );
  },
);

PublicAssetCustomFieldPlainTextInputTableCell.displayName = 'PublicAssetCustomFieldPlainTextInputTableCell';
